import { toast } from 'material-react-toastify';
import { BasketSummary } from '../../interfaces/Basket/BasketSummary';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { BasketItem } from '../../interfaces/Basket/BasketItem';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { DataTable } from '../../components/DataTable/DataTable';
import { updateBasketItemQuantity } from '../../utils/Basket';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';
import { BasketAmountInput } from './BasketAmountInput';

type BasketTableProps = {
  basket: BasketSummary;
  onUpdate: () => void;
};

export const BasketTable = ({ basket, onUpdate }: BasketTableProps) => {
  const handleDelete = (row: BasketItem) => {
    updateBasketItemQuantity(row, 0)
      .then(onUpdate)
      .catch((err) => toast.error(err.message));
  };

  const handleChangeQuantity = (row: BasketItem, newQuantity: number) => {
    updateBasketItemQuantity(row, newQuantity)
      .then(onUpdate)
      .catch((err) => toast.error(err.message));
  };

  const columns: TableColumn<BasketItem>[] = [
    {
      id: 'image',
      name: 'Resim',
      accessor: (row) => <ImageColumn url={row.product.baseImage.path} />,
      align: 'center',
    },
    {
      id: 'name',
      name: 'İsim',
      accessor: (row) => (
        <TextColumn
          value={row.product.name}
          secondary={row.options[0]?.item.label}
        />
      ),
    },
    {
      id: 'quantity',
      name: 'Adet',
      accessor: (row) => (
        <BasketAmountInput
          basketItem={row}
          onChange={(x) => handleChangeQuantity(row, x)}
        />
      ),
    },
    {
      id: 'total',
      name: 'Tutar',
      accessor: (row) => <PriceColumn value={row.total.amount} />,
    },
    {
      id: 'delete',
      name: 'İşlem',
      accessor: (row) => (
        <ButtonColumn label='Sil' onClick={() => handleDelete(row)} />
      ),
      align: 'center',
    },
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={basket.items.length}
      rows={basket.items}
      hidePagination
      linkGenerator={(item) => `/urun/${item.product.slug}`}
    />
  );
};
